import WishlistExchangeButtonComponent from "@/components/Wishlist/WishlistExchangeButton/wishlistExchangeButton.component";

type WishlistExchangeButtonsProps = {
    isLoggedIn: boolean;
    sku: string;
    currentWishlistId: string;
    canMove: boolean;
    onMove?: (sku: string, currentWishlistId: string) => void;
};

const WishlistExchangeButton = ({
    isLoggedIn,
    sku,
    currentWishlistId,
    canMove,
    onMove
}: WishlistExchangeButtonsProps) => {
    if (!isLoggedIn || !canMove) return null;

    return (
        <WishlistExchangeButtonComponent
            sku={sku}
            currentWishlistId={currentWishlistId}
            onMove={onMove}
        />
    );
};

export default WishlistExchangeButton;
